import { create } from "zustand"
import { ImageUploaded } from "@/components/AIAgent/ChatInput/useChatImageUpload"

interface ChatStore {
  initialPrompt: string
  searchConversation: string
  initialAttachedImages: ImageUploaded[]
  setInitialPrompt: (prompt: string) => void
  clearInitialPrompt: () => void
  setSearchConversation: (search: string) => void
  clearSearchConversation: () => void
  setInitialAttachedImages: (images: ImageUploaded[]) => void
  clearInitialAttachedImages: () => void
}

export const useChatStore = create<ChatStore>((set) => ({
  initialPrompt: "",
  searchConversation: "",
  initialAttachedImages: [],
  setInitialPrompt: (prompt) => set({ initialPrompt: prompt }),
  clearInitialPrompt: () => set({ initialPrompt: "" }),
  setSearchConversation: (search) => set({ searchConversation: search }),
  clearSearchConversation: () => set({ searchConversation: "" }),
  setInitialAttachedImages: (images) => set({ initialAttachedImages: images }),
  clearInitialAttachedImages: () => {
    console.log('Clear attached images')
    set({ initialAttachedImages: [] })
  },
}))